module.exports = __webpack_public_path__ + "static/img/pm2_5.de64ce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pm2_5.png
// module id = /0+W
// module chunks = 1